import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=41407ea7&"
import script from "./platform.vue?vue&type=script&lang=js&"
export * from "./platform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports